export default __webpack_public_path__ + "static/media/mortgage-homebuddy.bc62ce8b.svg";